import React from 'react';
import About from '../../components/about/about.component';
import Contact from '../../components/contact/contact.component';
import SlickSlider from '../../components/slick-slider/slick-slider.component';

const Homepage = () => {
    const sliderSettings = {
        autoplay: true,
        arrows: false,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
    };

    const sliderImages = [
        'images/general/slider/slide-01.jpg',
        'images/general/slider/slide-02.jpg',
        'images/general/slider/slide-03.jpg',
        'images/general/slider/slide-04.jpg',
        'images/general/slider/slide-05.jpg',
        'images/general/slider/slide-06.jpg',
        'images/general/slider/slide-07.jpg',
        'images/general/slider/slide-08.jpg',
        'images/general/slider/slide-09.jpg',
        'images/general/slider/slide-10.jpg',
        'images/general/slider/slide-11.jpg',
        'images/general/slider/slide-12.jpg',
        'images/general/slider/slide-13.jpg',
        'images/general/slider/slide-14.jpg',
        'images/general/slider/slide-15.jpg',
    ];

    return (
        <div>
            <SlickSlider settings={sliderSettings} images={sliderImages} />
            <About />
            <Contact />
        </div>
    );
};

export default Homepage;
